import React, { useEffect, useState } from 'react'
import classes from "./veryNewProposalDesign.module.scss";
import moment from 'moment';
import SingleAccomodationCard from './SingleAccomodationCard';
import InformationContainer from './InformationContainer';
import SingleFlightCard from './SingleFlightCard';
import SingleTranferCard from './SingleTranferCard';
import { SEND_EMAIL, UPDATE_BUILDER_DATA, UPDATE_DYNAMIC_ACCOMMODATION, UPDATE_DYNAMIC_ACTIVITY, UPDATE_DYNAMIC_CARRENTAL, UPDATE_DYNAMIC_CRUISE, UPDATE_DYNAMIC_FERRY, UPDATE_DYNAMIC_FLIGHT, UPDATE_DYNAMIC_RESTAURANT, UPDATE_DYNAMIC_TRAIN, UPDATE_DYNAMIC_TRANSFER } from "../../graphQL/mutations";
import { useMutation } from "@apollo/client";
import CommonDisplayCard from './CommonDisplayCard';
import { useAuth0, User } from '@auth0/auth0-react';
import SuccessPage from '../tripOverview/successPage';
import SingleSliderCard from './SingleSliderCard';
import { StarsSvg } from '../../constants/resources';
import EmailTemplate from '../../atom/EmailTemplate';
import { ItineraryAccommodation, ItineraryActivity, ItineraryCarRental, ItineraryFerry, ItineraryFlight, ItineraryRestaurant, ItineraryTrain, SortedItem, TravelAnswer, UserProfile, day, itinerary } from '../../atom/Types'
import AccommodationModal from '../tripOverview/Common/AccommodationModal';
import FlightModal from '../tripOverview/Common/FlightModal';
import CarModal from '../tripOverview/Common/CarModal';
import FerryModal from '../tripOverview/Common/FerryModal';
import TrainModal from '../tripOverview/Common/TrainModal';
import ActRest from '../tripOverview/Common/ActRest';
import { useSelector } from 'react-redux';
import { RootState } from '../../App';
import { checkSpacing, isFlight, keyExistInObject } from '../../atom/utilities/function';
import { getENVData } from '../../constants/constantValue';


interface props {
    buliddata: itinerary;
    setbuilddata: React.Dispatch<React.SetStateAction<itinerary | undefined>>;
    successEmail: string;
    setSuccessEmail: React.Dispatch<React.SetStateAction<string>>;
    Itinerarydata: TravelAnswer
}
export interface index {
    start: number;
    end: number
}
export interface selectArray {
    location: string | null | undefined
    data: SortedItem
}

const VeryNewProposlDesign: React.FC<props> = ({ buliddata, setbuilddata, successEmail, setSuccessEmail, Itinerarydata }) => {

    const [Email] = useMutation(SEND_EMAIL, {
        onError: (error) => {
        }
    })

    const { user, isAuthenticated } = useAuth0();
    const { Profile } = useSelector((state: RootState) => state.Question);
    const [totalPackagePrice, setTotalPackagePrice] = useState<number>(0)
    const [selectArray, setSelectedArray] = useState<selectArray[]>([])
    const [modal, setModal] = useState<boolean>(false)
    const selectedAccomodationID = ""
    const [accomodationModal, setAccomodationModal] = useState(false);
    const [activeAccomodation, setActiveAccomodation] = useState<ItineraryAccommodation>()
    const [flightInfoModal, setFlightInfoModal] = useState(false);
    const [activeFlight, setActiveFlight] = useState<ItineraryFlight[]>([]);
    const [carRental, setCarRental] = useState<boolean>(false)
    const [activeCarRental, setActiveCarRental] = useState<ItineraryCarRental | {}>({})
    const [carDetails, setCarDetails] = useState<ItineraryCarRental[]>([])
    const [trainModal, setTrainModal] = useState<boolean>(false)
    const [activeTrain, setActiveTrain] = useState<ItineraryTrain | {}>({})
    const [TrainDetails, setTrainDetails] = useState<ItineraryTrain[]>([])
    const [ferryModal, setFerryModal] = useState<boolean>(false)
    const [activeferry, setActiveFerry] = useState<ItineraryFerry | {}>({})
    const [ferryDetails, setFerryDetails] = useState<ItineraryFerry[]>([])
    const [suggestedModal, setSuggestedModal] = useState(false)
    const [suggesionData, setSuggesionData] = useState<ItineraryActivity | ItineraryRestaurant>()
    const [currentIndices, setCurrentIndices] = useState<index[]>([])
    const transportationTypes = ['flight', 'carRental', 'train', 'ferry'];
    const env = getENVData()

    const [AccommodationStatus] = useMutation(UPDATE_DYNAMIC_ACCOMMODATION, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [TrainStatus] = useMutation(UPDATE_DYNAMIC_TRAIN, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [FerryStatus] = useMutation(UPDATE_DYNAMIC_FERRY, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [FlightStatus] = useMutation(UPDATE_DYNAMIC_FLIGHT, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })

    const [CarRentalStatus] = useMutation(UPDATE_DYNAMIC_CARRENTAL, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [RestaurantStatus] = useMutation(UPDATE_DYNAMIC_RESTAURANT, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [ActivityStatus] = useMutation(UPDATE_DYNAMIC_ACTIVITY, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [TransferStatus] = useMutation(UPDATE_DYNAMIC_TRANSFER, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [CruiseStatus] = useMutation(UPDATE_DYNAMIC_CRUISE, {
        variables: { id: '', bookingStatus: '', isVisible: '' }
    })
    const [updateItinerary] = useMutation(UPDATE_BUILDER_DATA, {
        variables: { id: '', type: '' }
    })

    useEffect(() => {
        let temp: index[] = []
        if (buliddata?.proposalView) {
            for (let index = 0; index < buliddata?.proposalView?.length; index++) {
                temp.push({ start: 0, end: window.innerWidth > 600 ? 1 : 0 })
            }
            setCurrentIndices(temp)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [window.innerWidth])

    useEffect(() => {
        let transferPrice: number = 0
        let flightPrice: number = 0
        let roomPrice: number = 0
        let trainPrice: number = 0
        let ferryPrice: number = 0
        let carRentalPrice: number = 0
        let activityPrice: number = 0

        buliddata?.days.forEach((node: day) => {
            if (node.sorted && node?.sorted?.length > 0) {
                let transfer = node?.sorted?.filter((n) => {
                    return n.type === 'transfer' && n.selected === true
                })
                if (transfer.length > 0 && 'price' in transfer[0] && transfer[0]?.price)
                    transferPrice = transferPrice + transfer[0]?.price

                let flight = node?.sorted?.filter((n) => { return n.type === "flight" && n.selected === true && 'visibility' in n && n?.visibility === true })

                if (flight[0] && 'price' in flight[0] && flight[0].price !== null) {
                    if ('connectionFlights' in flight[0] && flight[0]?.connectionFlights?.length > 0) {
                        flight[0]?.connectionFlights.forEach((element) => {
                            flightPrice = flightPrice + (element.price ? element.price : 0)
                        });
                    }
                    if ('returnItineraryFlight' in flight[0] && flight[0].returnItineraryFlight !== null) {

                        if ('connectionFlights' in flight[0]?.returnItineraryFlight && flight[0]?.returnItineraryFlight.connectionFlights?.length > 0) {
                            flight[0]?.returnItineraryFlight.connectionFlights.forEach((element) => {
                                flightPrice = flightPrice + (element.price ? element.price : 0)
                            });
                        }
                        flightPrice = flightPrice + flight[0]?.price + ('price' in flight[0]?.returnItineraryFlight && flight[0]?.returnItineraryFlight?.price ? flight[0]?.returnItineraryFlight?.price : 0)

                    }
                    else { flightPrice = flightPrice + flight[0]?.price }
                }
                node?.dayAccommodations?.forEach((node) => {

                    node?.roomDetails?.filter((n) => {
                        if (n.selected === true && n.price && n.count && n.price >= 0)
                            return roomPrice = roomPrice + (n.price * n?.count) + (node?.benchmarkPrice > 0 ? node?.benchmarkPrice : node?.packagePrice > 0 ? node?.packagePrice : node?.seaparatePrice ? node?.seaparatePrice : 0)
                        else
                            return 0
                    })
                })
                let carRental = node?.sorted?.filter((n) => { return n.type === 'carRental' && n.selected === true })
                if (carRental[0] && 'price' in carRental[0] && carRental[0]?.price)
                    carRentalPrice = carRentalPrice + carRental[0]?.price

                let train = node?.sorted?.filter((n) => { return n.type === 'train' && n.selected === true })
                if (train[0] && 'price' in train[0] && train[0]?.price)
                    trainPrice = trainPrice + train[0]?.price

                let ferry = node?.sorted?.filter((n) => { return n.type === 'ferry' && n.selected === true })
                if (ferry[0] && 'price' in ferry[0] && ferry[0]?.price)
                    ferryPrice = ferryPrice + ferry[0]?.price
                let activity = node?.sorted?.filter((n) => { return n.type === 'activity' && n.selected === true })
                if (activity.length > 0) {
                    activity.forEach((act) => {
                        if ('netPrice' in act && 'count' in act)
                            activityPrice = activityPrice + (act?.netPrice * (act?.count ? act.count : 0))
                    })
                }

            }
        })
        setTotalPackagePrice(transferPrice + flightPrice + roomPrice + carRentalPrice + trainPrice + ferryPrice + activityPrice)

    }, [buliddata])

    useEffect(() => {
        const updateData = { ...buliddata }
        const array = [...selectArray];
        let privateNode: SortedItem[]
        let sharedNode: SortedItem[]
        updateData?.proposalView?.forEach((node, index: number) => {

            if (node?.value.length > 0) {
                privateNode = node?.value.filter((a) => { return (a.type === "transfer" && 'transferType' in a && a.transferType === "Private") })
                sharedNode = node?.value.filter((a) => { return (a.type === "transfer" && 'transferType' in a && a.transferType === "Group") })
            }
            if (privateNode?.length > 0) {
                privateNode[0].selected = true
                array.push({ location: updateData?.proposalView && updateData?.proposalView[index]?.location, data: privateNode[0] })
            } else if (sharedNode?.length > 0) {
                sharedNode[0].selected = true
                array.push({ location: updateData?.proposalView && updateData?.proposalView[index]?.location, data: sharedNode[0] })
            }
            handleTransfer(privateNode?.length > 0 ? "Private" : sharedNode?.length > 0 ? "Group" : 'null', index)

        })
        setSelectedArray([...array]);
        setbuilddata({ ...updateData })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])




    // const GenHTMLTemplate = () => {
    //     var Main = ReactDOMServer.renderToString(<EmailTemplate buliddata={buliddata} Profile={keyExistInObject(Profile as UserProfile, '') as UserProfile} />);
    //     return Main
    // }

    const arrayTransfer = (node: SortedItem[], type: string, day: number) => {

        const array = [...selectArray]
        const index = array.findIndex((n) => (n.location === (buliddata?.proposalView && buliddata?.proposalView[day]?.location) && n.data.type === "transfer"))

        if (index > -1) {
            array.splice(index, 1)
        }
        if (node.length > 0) {
            array.push({ location: buliddata?.proposalView && buliddata?.proposalView[day]?.location, data: node[0] })
        }
        setSelectedArray([...array]);
    }

    const handleTransfer = (type: string, day: number) => {
        const updateData = { ...buliddata }
        if (updateData.proposalView) {
            updateData.proposalView[day].transferName = type
            updateData.proposalView && updateData.proposalView[day]?.value.filter((node) => node.type === 'transfer').forEach((n) => {
                if ('transferType' in n && n.transferType === type) {
                    n.selected = true
                } else n.selected = false
            })
            setbuilddata({ ...updateData })
            const node = updateData.proposalView[day]?.value.filter((node) => (node.type === 'transfer' && 'transferType' in node && node.transferType === type))
            arrayTransfer(node, type, day)
        }
    }

    const handleCarRental = (n: ItineraryCarRental[], m: string) => {
        const array = [...selectArray]
        if (m === 'close') {
            if (activeCarRental && Object.keys(activeCarRental).length === 0) {

                const updateData = { ...buliddata }
                updateData.proposalView && updateData.proposalView.forEach((days) =>
                    days.value.filter((node) => { return node.type === 'carRental' }).forEach((data) => {
                        data.selected = false
                        if (data.selected === false) {
                            const index = array.findIndex((n) => n.data.id === data.id)
                            if (index > -1) {
                                array.splice(index, 1)
                                setSelectedArray([...array]);
                            }
                        }
                    }))
                setbuilddata({ ...updateData })
            }
            setCarRental(false)
            setActiveCarRental({})
        }
        else if (m === 'choose') {

            const updateData = { ...buliddata }
            updateData.proposalView && updateData.proposalView.forEach((days) =>
                days.value.filter((node) => { return node.type === 'carRental' }).forEach((data) => {
                    if ('id' in activeCarRental && data.id === activeCarRental.id) {
                        data.selected = true
                    } else data.selected = false
                    if (data.selected) {
                        array.push({ location: days.location, data: data })
                        setSelectedArray([...array]);
                    } else if (data.selected === false) {
                        const index = array.findIndex((n) => n.data.id === data.id)
                        if (index > -1) {
                            array.splice(index, 1)
                            setSelectedArray([...array]);
                        }
                    }
                })
            )
            setbuilddata({ ...updateData })
            setCarRental(false)
            setActiveCarRental({})
        }
        else {

            let temp = n?.filter((node) => { return node?.type === 'carRental' && node?.selected === true })

            if (temp.length > 0)
                setActiveCarRental(temp[0])
            setCarRental(true)
            setCarDetails(n?.filter((node) => { return node?.type === 'carRental' }))

        }
    }


    const handleTrain = (n: ItineraryTrain[], m: string,) => {


        const array = [...selectArray]

        if (m === 'close') {
            if (activeTrain && Object.keys(activeTrain).length === 0) {

                const updateData = { ...buliddata }
                updateData.proposalView && updateData.proposalView.forEach((days) =>
                    days.value.filter((node) => { return node.type === 'train' }).forEach((data) => {
                        data.selected = false
                        if (data.selected === false) {
                            const index = array.findIndex((n) => n.data.id === data.id)
                            if (index > -1) {
                                array.splice(index, 1)
                                setSelectedArray([...array]);
                            }
                        }
                    }))
                setbuilddata({ ...updateData })
            }
            setTrainModal(false)
            setActiveTrain({})
        }
        else if (m === 'choose') {

            const updateData = { ...buliddata }

            updateData.proposalView && updateData.proposalView.forEach((days) =>
                days.value.filter((node) => { return node.type === 'train' }).forEach((data) => {
                    if ('id' in activeTrain && data.id === activeTrain.id) {
                        data.selected = true
                    } else data.selected = false
                    if (data.selected) {
                        array.push({ location: days.location, data: data })
                        setSelectedArray([...array]);
                    } else if (data.selected === false) {
                        const index = array.findIndex((n) => n.data.id === data.id)
                        if (index > -1) {
                            array.splice(index, 1)
                            setSelectedArray([...array]);
                        }
                    }
                })
            )
            setbuilddata({ ...updateData })
            setTrainModal(false)
            setActiveTrain({})
        }

        else {
            let temp = n?.filter((node) => { return node?.type === 'train' && node?.selected === true })

            if (temp.length > 0)
                setActiveTrain(temp[0])
            setTrainModal(true)
            setTrainDetails(n?.filter((node) => { return node?.type === 'train' }))
        }
    }

    const handleFerry = (n: ItineraryFerry[], m: string) => {
        const array = [...selectArray]

        if (m === 'close') {
            if (activeferry && Object.keys(activeferry).length === 0) {

                const updateData = { ...buliddata }
                updateData.proposalView && updateData.proposalView.forEach((days) =>
                    days.value.filter((node) => { return node.type === 'ferry' }).forEach((data) => {
                        data.selected = false
                        if (data.selected === false) {
                            const index = array.findIndex((n) => n.data.id === data.id)
                            if (index > -1) {
                                array.splice(index, 1)
                                setSelectedArray([...array]);
                            }
                        }
                    }))
                setbuilddata({ ...updateData })
            }
            setFerryModal(false)
            setActiveFerry({})
        }
        else if (m === 'choose') {

            const updateData = { ...buliddata }
            updateData.proposalView && updateData.proposalView.forEach((days) =>
                days.value.filter((node) => { return node.type === 'ferry' }).forEach((data) => {
                    if ('id' in activeferry && data.id === activeferry.id) {
                        data.selected = true
                    } else data.selected = false
                    if (data.selected) {
                        array.push({ location: days.location, data: data })
                        setSelectedArray([...array]);
                    } else if (data.selected === false) {
                        const index = array.findIndex((n) => n.data.id === data.id)
                        if (index > -1) {
                            array.splice(index, 1)
                            setSelectedArray([...array]);
                        }
                    }
                })
            )
            setbuilddata({ ...updateData })
            setFerryModal(false)
            setActiveFerry({})

        }
        else {
            let temp = n?.filter((node) => { return node?.type === 'ferry' && node?.selected === true })

            if (temp.length > 0)
                setActiveFerry(temp[0])
            setFerryModal(true)
            setFerryDetails(n?.filter((node) => { return node?.type === 'ferry' }))

        }
    }

    const handleSuggested = (node: ItineraryRestaurant | ItineraryActivity | ItineraryAccommodation) => {
        const updateData = { ...buliddata }
        const array = [...selectArray];
        updateData?.proposalView && updateData?.proposalView.forEach((days) => days.value.filter((node) => { return node.type === 'activity' || node.type === 'Restaurant' }).forEach((sug) => {
            if (sug.id === node.id) {
                sug.selected = !sug.selected
            }
            if (sug.selected && sug.id === node.id) {
                array.push({ location: days.location, data: node })
                setSelectedArray([...array]);
            } else if (sug.selected === false) {
                const index = array.findIndex((n) => n.data.id === sug.id)
                if (index > -1) {
                    array.splice(index, 1)
                    setSelectedArray([...array]);
                }
            }
        }))

        setbuilddata({ ...updateData })
        setSuggestedModal(false)
    }

    const submitProposal = () => {
        setModal(true)
        if (isAuthenticated && (Itinerarydata?.email?.toLowerCase() === (keyExistInObject(Profile as UserProfile, "email") as String)?.toLowerCase() ||
            Itinerarydata?.sharedEmails?.map(m => m.toLowerCase()).includes(keyExistInObject(Profile as UserProfile, "email").toString().toLowerCase()))) {
            const promises = []
            const apicalls = [
                { type: 'accommodation', apiFunction: AccommodationStatus },
                { type: 'train', apiFunction: TrainStatus },
                { type: 'ferry', apiFunction: FerryStatus },
                { type: 'flight', apiFunction: FlightStatus },
                { type: 'carRental', apiFunction: CarRentalStatus },
                { type: 'Restaurant', apiFunction: RestaurantStatus },
                { type: 'activity', apiFunction: ActivityStatus },
                { type: 'transfer', apiFunction: TransferStatus },
                { type: 'cruises', apiFunction: CruiseStatus },

            ]
            setSuccessEmail('Loading')
            buliddata?.proposalView?.forEach((place) => {
                place?.value?.forEach((node) => {
                    const apiCall = apicalls.find((call) => { return call.type === node.type && node.selected })
                    if (apiCall) {


                        promises.push(new Promise(resolve => {
                            setTimeout(() => {
                                apiCall.apiFunction({
                                    variables: { id: node.id, bookingStatus: "InProgress", isVisible: true }
                                }).then(res => resolve(res))
                                    .catch(err => resolve(err));
                            }, 2000);
                        }));
                    }
                    else {


                        const updateApiCall = apicalls.find((call) => { return call.type === node.type && 'bookingStatus' in node && node.bookingStatus === 'Proposal' })
                        if (updateApiCall) {


                            promises.push(new Promise(resolve => {
                                setTimeout(() => {
                                    updateApiCall.apiFunction({
                                        variables: { id: node.id, bookingStatus: "Proposal", isVisible: false }
                                    }).then(res => resolve(res))
                                        .catch(err => resolve(err));
                                }, 2000);
                            }));
                        }
                    }
                })
            })
            if (buliddata?.type === 'Proposal') {
                promises.push(new Promise(resolve => {
                    updateItinerary({ variables: { id: buliddata?.id, type: 'Actual' } })
                        .then(res => resolve(res))
                        .catch(err => resolve(err));

                }))
            }

            Promise.all(promises).then(() => {
                setSuccessEmail('Loading')
                const email = EmailTemplate(buliddata, keyExistInObject(Profile as UserProfile, '') as UserProfile, user as User, [], '');
                if (email) {
                    Email({
                        variables: {
                            to: env.email,
                            ccEmails: env.subEmail,
                            subject: `${Object.keys(Profile).length > 0 && keyExistInObject(Profile as UserProfile, 'firstName') ? keyExistInObject(Profile as UserProfile, 'firstName') : buliddata?.travelAnswer?.name ? buliddata?.travelAnswer?.name : user?.nickname},  ${buliddata?.name} , has submitted proposal`,
                            body: email,
                            submitTime: 1685950252
                        }
                    }).then((response) => {
                        if (response.errors === undefined) {
                            setSuccessEmail('Success')
                        } else {
                            setSuccessEmail('Error')
                        }
                    })
                }
            }).catch((err => {

                setSuccessEmail('failed')

            }))


        }
        else if (isAuthenticated && Itinerarydata?.email !== keyExistInObject(Profile as UserProfile, "email")) {
            setSuccessEmail('misMatch')
        }
        else {
            setSuccessEmail('notLogged')
        }

    }

    // const handlePayment = async () => {
    //     ;
    //     //const search = (window.location.search?.length > 0 ? window.location.search : "").split("&");

    //     //history.push(routes.PAYMENT + `/${buliddata.id}`);
    //     history.push(routes.PAYMENT, { id: buliddata.id });
    //     //history.push({ pathname: routes.PAYMENT, search: window.location.search });
    //     return;

    //     try {
    //         const res = await Helper.sendToPaymentPromise("itinararyPayments", {
    //             props: {
    //                 data: buliddata,
    //                 profile: UserProfile,
    //                 email: successEmail
    //             },
    //             onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
    //                 showMessage(title, message, type);
    //             }
    //         });

    //         // const res = await Helper.sendToPaymentPromise("squareCreditPayment", {
    //         //     onNotify: (title: string, message: string, type: "success" | "danger" | "info" | "default" | "warning") => {
    //         //         showMessage(title, message, type);
    //         //     }
    //         // });
    //     }
    //     catch (ex: any) {
    //         // ;
    //     }
    // }

    return <div className={classes.MainContainer}>
        {/* <div id="paymentDiv"></div>  */}
        {/* {isLocalDev && <div><Button style={{ backgroundColor: 'red' }} variant='contained' onClick={() => handlePayment()}>Credit Card Payment</Button></div>} */}


        <div className={classes.PackageContainer} hidden={buliddata.isPackagePrice === false || buliddata?.isPackagePrice === null}>
            <div className={classes.PackageInfoBox}>
                <div style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "center" }}>
                    <div className={classes.PackagePrice}>
                        ${totalPackagePrice}
                    </div>
                    <div className={classes.header}>Package price</div>
                </div>
                <div className={classes.PackageDescription}>
                    For two persons (includes flights, accomodation and transfer).
                </div>
            </div>
        </div>

        <div className={classes.TravelGuideContainer}>
            <div className={classes.header}>{buliddata?.name}</div>
            <div className={classes.box}>
                <div id="eventMonitor" className={classes.comment} dangerouslySetInnerHTML={{ __html: buliddata?.tripOverview }}></div>
            </div>
            <div className={classes.box}>
                <div id="eventMonitor1" className={classes.comment} style={{ marginTop: '20px' }} dangerouslySetInnerHTML={{ __html: buliddata?.comment }}></div>

            </div>
            <hr />
        </div>

        {(() => {
            const filteredProposals = buliddata?.proposalView?.filter((node) =>
                // eslint-disable-next-line array-callback-return
                node?.value.some((n) => {
                    if ('bookingStatus' in n)
                        return transportationTypes.includes(n.type) && n.bookingStatus === 'Proposal'
                }
                )
            ) || [];
            if (filteredProposals.length > 0) {
                return <div className={classes.FlightContainer}>
                    <div className={classes.header}>Transportation</div>
                </div>
            }
        })()}

        {
            buliddata?.proposalView && buliddata.proposalView.length > 0 &&
            buliddata.proposalView.map((node, ind) => {
                const flightRentals = node.value.filter(isFlight).filter(n => n.type === 'flight' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
                if (flightRentals.length > 0) {
                    return (
                        flightRentals.map((flight) => {
                            return <React.Fragment key={ind}>
                                <SingleFlightCard
                                    singleFlightData={flight}
                                    ind={ind}
                                    day={ind + 1}
                                    setFlightInfoModal={setFlightInfoModal}
                                    setActiveFlight={setActiveFlight}
                                />
                                <InformationContainer data={buliddata} name={"Flight"} />
                            </React.Fragment>
                        }))
                }
                return null;
            })}

        {buliddata?.proposalView && buliddata.proposalView.length > 0 &&
            buliddata.proposalView.map((node, ind) => {
                const carRentals = node?.value?.filter(n => n.type === 'carRental' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
                if (carRentals.length > 0) {
                    return <React.Fragment key={ind}>
                        <CommonDisplayCard
                            node={carRentals}
                            handleCarRental={handleCarRental}
                            ind={ind}
                        />
                    </React.Fragment>
                }
                return null;
            })}
        {buliddata?.proposalView && buliddata?.proposalView?.length > 0 && buliddata?.proposalView.map((node, ind: number) => {
            const trainRentals = node?.value?.filter(n => n.type === 'train' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
            if (trainRentals.length > 0) {
                return <React.Fragment key={ind}>
                    <CommonDisplayCard
                        node={trainRentals}
                        handleTrain={handleTrain}
                        ind={ind}
                    />
                </React.Fragment>
            }
            return null
        })}
        {buliddata?.proposalView && buliddata?.proposalView?.length > 0 && buliddata?.proposalView.map((node, ind: number) => {
            const ferryRentals = node?.value?.filter(n => n.type === 'ferry' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
            if (ferryRentals.length > 0) {
                return <React.Fragment key={ind}>
                    <CommonDisplayCard
                        node={ferryRentals}
                        handleFerry={handleFerry}
                        ind={ind}
                    />
                </React.Fragment>
            }
            return null
        })}
        {buliddata?.proposalView && buliddata?.proposalView.length > 0 &&
            buliddata.proposalView.map((node, ind: number) => {
                const activitiesAndRestaurants = node.value.filter(n => (n.type === "activity" || n.type === "Restaurant") && 'isAddToSuggession' in n && n.isAddToSuggession && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
                const accommodations = node.value.filter(n => n.type === 'accommodation' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
                const transfers = node.value.filter(n => n.type === 'transfer' && 'bookingStatus' in n && n.bookingStatus === 'Proposal');
                let temp = (node.value.filter((n) => { return (n.type === "activity" || n.type === "Restaurant") && 'isAddToSuggession' in n && n.isAddToSuggession && 'bookingStatus' in n && n.bookingStatus === 'Proposal' }).length)
                const filteredAdditionalInfo = node.value.filter((n) => n.type === 'additionalInfo')
                return <div key={ind} >
                    {activitiesAndRestaurants.length > 0 || accommodations.length > 0 || transfers.length > 0 ?
                        <div className={classes.dayOverview}>
                            <div className={classes.dayLocation}>
                                <div>{node?.location}</div>
                                <div>{moment.utc(node?.date[0]).format('MMM D')}-{moment.utc(node?.date[node?.date.length - 1]).format('MMM D')}</div>
                            </div>
                            {/* accommodation Container */}
                            {accommodations.length > 0 && (<div className={classes.AccomodationContaianer}>
                                <div className={classes.header}>Accomodation</div>
                                <div className={classes.AccomodationCardsContainer}>
                                    {accommodations.map((node, index) => (
                                        <SingleAccomodationCard
                                            ind={ind}
                                            day={ind + 1}
                                            singleAccomodationNode={node}
                                            key={node.id}
                                            selectedAccomodationID={selectedAccomodationID}
                                            setAccomodationModal={setAccomodationModal}
                                            setActiveAccomodation={setActiveAccomodation}
                                        />
                                    ))}
                                </div>
                                <InformationContainer data={buliddata} name={"Accommodation"} />
                                <hr />
                            </div>)}

                            {/* ------------ Transfer Container----------- */}
                            {transfers.length > 0 && (<div className={classes.TransferContainer}>

                                <div className={classes.header}>Transfer</div>
                                <div className={classes.SwitchContainer}>
                                    <div className={classes.option}
                                        onClick={() => handleTransfer("Group", ind)}
                                        style={{
                                            backgroundColor: `${node.transferName === "Group" ? "#0094FF" : ""} `,
                                            color: `${node.transferName === "Group" ? "white" : "#758191"} `
                                        }}>Shared</div>
                                    <div className={classes.option}
                                        onClick={() => handleTransfer("Private", ind)}
                                        style={{
                                            backgroundColor: `${node.transferName === "Private" ? "#0094FF" : ""} `,
                                            color: `${node.transferName === "Private" ? "white" : "#758191"} `
                                        }}
                                    >Private</div>
                                    <div className={classes.option}
                                        onClick={() => { handleTransfer('null', ind) }}
                                        style={{
                                            backgroundColor: `${node.transferName === null ? "#0094FF" : ""} `,
                                            color: `${node.transferName === null ? "white" : "#758191"} `
                                        }}
                                    >Not Needed</div>
                                </div>
                                <div className={classes.TranferDetails}>
                                    {buliddata?.proposalView && node.transferName !== null ?
                                        node?.value?.filter((nodess) => (nodess.type === 'transfer' && 'transferType' in nodess && nodess.transferType === node.transferName && 'bookingStatus' in node && node.bookingStatus === 'Proposal')).length > 0 ? node?.value?.filter((nodess) => (nodess.type === 'transfer' && nodess.selected === true)).map((n, ind) => {

                                            return <React.Fragment key={ind}>
                                                <SingleTranferCard
                                                    singleTranferData={n}
                                                    node={node}
                                                />
                                            </React.Fragment>
                                        })
                                            : <div className={classes.SingleTransferCardNoNeeded}><p>
                                                No {node.transferName} Found
                                            </p></div>
                                        :
                                        <div className={classes.SingleTransferCardNoNeeded}><p>
                                            No Transfer Needed
                                        </p></div>}
                                </div>
                                <InformationContainer data={buliddata} name={"Transfer"} />
                                <hr />
                            </div>)}
                            {activitiesAndRestaurants.length > 0 &&
                                <React.Fragment>
                                    <p className={classes.sliderHead}><span><StarsSvg /> Suggested Tours and Activities</span></p>
                                    <div className={classes.grids}>
                                        {activitiesAndRestaurants.filter((sug, index) => { return index >= currentIndices[ind]?.start && index <= currentIndices[ind]?.end }).map((node, indd) => {
                                            return <React.Fragment key={indd}>
                                                <SingleSliderCard
                                                    handleSuggested={handleSuggested}
                                                    index={ind}
                                                    end={temp}
                                                    singleNode={node}
                                                    setCurrentIndices={setCurrentIndices}
                                                    currentIndices={currentIndices}
                                                    ind={indd}
                                                    scrollIndex={ind}
                                                    setSuggesionData={setSuggesionData}
                                                    setSuggestedModal={setSuggestedModal} />
                                            </React.Fragment>

                                        })
                                        }
                                    </div>
                                </React.Fragment>}
                        </div> : null}

                    {filteredAdditionalInfo.length > 0 && filteredAdditionalInfo
                        .sort((a, b) => {
                            if (a.sortTime === null || b.sortTime === null)
                                return -1
                            else
                                return new Date(a.sortTime).getTime() - new Date(b.sortTime).getTime()
                        })
                        .map((info) => (
                            <div key={info.sortTime} className={classes.TravelGuideContainer}>
                                <div className={classes.header}>{'title' in info && info?.title}</div>
                                {'description' in info && info?.description ? <div className={classes.box}>
                                    <div
                                        id="eventMonitor"
                                        className={classes.comment}
                                        dangerouslySetInnerHTML={{ __html: info?.description }} />
                                </div> : null}
                                <hr />
                            </div>
                        ))}

                    {node.description.some((desc) => checkSpacing(desc)) &&
                        <div className={classes.TripOverviewContainer}>
                            <div className={classes.header}>Trip Overview</div>
                            <div className={classes.TripOverviewInfoContainer}>
                                <div className={classes.header}>{buliddata?.name}</div>
                                {node.description.filter((desc) => { return checkSpacing(desc) }).map((val, index) => {
                                    return (index === 0 && <div className={classes.InfoText}>
                                        <div id="eventMonitor" className={classes.tripOverview} dangerouslySetInnerHTML={{ __html: val }}></div>
                                    </div>)
                                })}
                            </div>
                        </div>}
                </div>
            })}

        {/* ------------ Submit Proposal ------------- */}
        <div className={classes.SubmitButton}>
            <button disabled={selectArray.length > 0 ? false : true} onClick={() => submitProposal()}>
                Submit
            </button>
        </div>
        {accomodationModal ? <AccommodationModal selectArray={selectArray} setSelectedArray={setSelectedArray} activeAccomodation={activeAccomodation} setAccomodationModal={setAccomodationModal} buliddata={buliddata} setbuilddata={setbuilddata} /> : null}
        {flightInfoModal ? <FlightModal setFlightInfoModal={setFlightInfoModal} buliddata={buliddata} activeFlight={activeFlight} selectArray={selectArray} setSelectedArray={setSelectedArray} setbuilddata={setbuilddata} /> : null}
        {carRental ? <CarModal buliddata={buliddata} activeCarRental={activeCarRental} handleCarRental={handleCarRental} carDetails={carDetails} setActiveCarRental={setActiveCarRental} /> : null}
        {ferryModal ? <FerryModal buliddata={buliddata} ferryDetails={ferryDetails} handleFerry={handleFerry} activeferry={activeferry} setActiveFerry={setActiveFerry} /> : null}
        {trainModal ? <TrainModal buliddata={buliddata} TrainDetails={TrainDetails} handleTrain={handleTrain} activeTrain={activeTrain} setActiveTrain={setActiveTrain} /> : null}
        {suggestedModal ? <ActRest suggesionData={suggesionData} setSuggestedModal={setSuggestedModal} handleSuggested={handleSuggested} /> : null}

        {modal ? <SuccessPage successEmail={successEmail} setModal={setModal} builddata={buliddata} selectArray={selectArray} /> : null}

    </div>
}

export default VeryNewProposlDesign;